import "../../css/userdashmenu.css"
import user from "../../media/user2.png"
import { Icon } from "@iconify/react"
import useStore from "../../store/zustandstore"
import { useRef, useEffect, use, useState } from "react"
import { useNavigate } from "react-router-dom"
import usefbStore from "../../store/firebasestore"
import { auth } from "../../firebase/firebase"
import { Navigate } from "react-router-dom"
import userNewbie from "../../media/undraw_chill-guy-avatar_tqsm.svg"
import userJourneyman from "../../media/undraw_indie-hacker-avatar_b3wy.svg"
import userMaster from "../../media/undraw_deep-thinker-avatar_6xg6.svg"
import userPro from "../../media/undraw_professor-avatar_y9ai.svg"
import { getAuth, signOut } from "firebase/auth"
import Swal from "sweetalert2";
function Userdashmenu() {
    const showPaymentMethod = useStore((s) => s.showPaymentMethod)
    const isUserProfileActive = useStore((s) => s.isUserProfileActive)
    const showAccountStatus = useStore((s) => s.showAccountStatus)
    const showUserProfile = useStore((s) => s.showUserProfile)
    const showAiTasks = useStore((s) => s.showAiTasks)
    const hideScreenLoader = useStore((s) => s.hideScreenLoader)
    const isUserDashboardActive = useStore((s) => s.isUserDashboardActive)
    const showUserDashboard = useStore((s) => s.showUserDashboard)
    const hideUserDashboard = useStore((s) => s.hideUserDashboard)
    const userName = usefbStore((s) => s.userName)
    const authStatus = usefbStore((s) => s.authStatus)
    const navigate = useNavigate()
    const hideUserDashNav = useStore((s) => s.hideUserDashNav)
    const showDesktopLeftDash = useStore((s) => s.showDesktopLeftDash)
    const hideDesktopLeftDash = useStore((s) => s.hideDesktopLeftDash)
    const [fname, setfname] = useState("")
    const showPayments = useStore((s) => s.showPayments)
    const accountPoints = usefbStore((s) => s.accountPoints) || 0;
    const userNavLinkActive = useStore((s) => s.userNavLinkActive)
    const showContracts = useStore((s) => s.showContracts)
    useEffect(() => {
        if (userName) {
            setfname(userName.split(" ")[0]);

        }
    }, [userName]);

    useEffect(() => {
        if (authStatus === 'authenticated' && userName != null) {
            hideScreenLoader()
        }
        return;
    }, [authStatus, userName])


    function getUserLevelImg(accountPoints) {
        if (accountPoints >= 5000) return userPro;
        if (accountPoints >= 3500) return userMaster;
        if (accountPoints >= 1000) return userJourneyman;
        return userNewbie;
    }

    const toUserDash = () => {
        hideUserDashNav()
        showUserDashboard()
    }
    const toAiTasks = () => {
        hideUserDashNav()
        showUserDashboard()
        showAiTasks()
    }
    const toProfileSettings = () => {
        hideUserDashNav()
        showAccountStatus()
    }

    const toStats = () => {
        hideUserDashNav()
        showUserProfile()
    }
    const toContracts = () => {
        showContracts()
        hideUserDashNav()
        hideDesktopLeftDash()

    }

    const toPaymentMethod = () => {
        showPaymentMethod()
        hideUserDashNav()
        hideDesktopLeftDash()
    }

    const toPayments = () => {
        hideUserDashNav()
        showPayments()
    }


    const logOut = () => {
        Swal.fire({
            title: "Are You Sure?",
            text: "Please confirm you are signing out!",
            icon: "question",
            showConfirmButton: true,
            confirmButtonText: "Log Out",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            cancelButtonColor: "#6a5acd"

        }).then((result) => {
            if (result.isConfirmed) {
                const auth = getAuth()
                signOut(auth).then(() => {
                    navigate("/auth")
                }).catch(() => {
                    Swal.fire("Error", "An error occured", "error")
                })
            }
        })
    }
    return (
        <div className="userDashNav">
            <div className="userProfile">
                <div className="userProfileImg">
                    <img src={getUserLevelImg(accountPoints)} alt="" />
                </div>
                <div className="userProfDataMini">
                    <span>{fname ? fname.charAt(0).toUpperCase() + fname.slice(1).toLowerCase() : ''}</span>
                </div>

            </div>
            <div className="userDashBtm">
                <div className="userDashLinks" >
                    <div onClick={() => toUserDash()} className={`udlLink ${userNavLinkActive == "Dashboard" ? "udlLinkActive" : ""}`}>
                        <div className="udlLinkIcon">
                            <Icon className="faIcon" icon="solar:armchair-2-outline" />

                        </div>
                        <div className="udlLinkMenu">
                            <p>Dashboard</p>
                        </div>
                    </div>
                    <div onClick={() => toAiTasks()} className={`udlLink ${userNavLinkActive == "AI-Tasks" ? "udlLinkActive" : ""}`}>
                        <div className="udlLinkIcon">
                            <Icon className="faIcon" icon="solar:square-academic-cap-linear" />

                        </div>
                        <div className="udlLinkMenu" >
                            <p>AI Tasks</p>
                        </div>
                    </div>
                    <div className={`udlLink ${userNavLinkActive == "Contracts" ? "udlLinkActive" : ""}`} onClick={() => toContracts()}>
                        <div className="udlLinkIcon">
                            <Icon className="faIcon" icon="solar:case-outline" />

                        </div>
                        <div className="udlLinkMenu">
                            <p>Contracts</p>
                        </div>
                    </div>
                    <div onClick={() => toStats()} className={`udlLink ${userNavLinkActive == "MyStats" ? "udlLinkActive" : ""}`}>
                        <div className="udlLinkIcon">
                            <Icon className="faIcon" icon="solar:diagram-up-bold" />
                        </div>
                        <div className="udlLinkMenu">
                            <p>My Stats</p>
                        </div>
                    </div>
                    <div onClick={toPayments} className={`udlLink ${userNavLinkActive == "Wallet" ? "udlLinkActive" : ""}`}>
                        <div className="udlLinkIcon">
                            <Icon className="faIcon" icon="solar:wallet-2-outline" />

                        </div>
                        <div className="udlLinkMenu">
                            <p>Wallet</p>

                        </div>
                    </div>


                    <div onClick={() => toPaymentMethod()} className={`udlLink ${userNavLinkActive == "Payment Method" ? "udlLinkActive" : ""}`}>
                        <div className="udlLinkIcon">
                            <Icon className="faIcon" icon="solar:verified-check-outline" />

                        </div>
                        <div className="udlLinkMenu">
                            <p>Payment Method</p>

                        </div>
                    </div>
                    <div onClick={() => toProfileSettings()} className={`udlLink ${userNavLinkActive == "Account Status" ? "udlLinkActive" : ""}`}>
                        <div className="udlLinkIcon">
                            <Icon className="faIcon" icon="solar:user-linear" />
                        </div>
                        <div className="udlLinkMenu">
                            <p>My Profile</p>
                        </div>
                    </div>


                </div>
                <div className="userDashBbtm">
                    <div className="usdbLogout">
                        <span>Taking a break? </span>
                        <p
                            onClick={() => logOut()}
                            style={{ cursor: 'pointer', fontWeight: '500' }}
                            onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                            onMouseLeave={(e) => e.target.style.opacity = '1'}
                        >
                            Log Out
                        </p>
                    </div>
                </div>

            </div>


        </div>
    )
}

export default Userdashmenu;